<template>
  <div class="store_item_list" v-if="layerpageinfo.total > 0">
    <!-- 店铺列表 -->
    <div class="store_list">
      <!-- 店铺标题 -->
      <div class="store_title">
        <div class="title_left">
          <p>{{title}}</p>
        </div>
        <div class="title_right">
          <i class="el-icon-arrow-left" @click="page('pre')"></i>
          <div class="title_right_text">
            <a
              href="javascript:;"
            >{{layerpageinfo.pageNo===0?layerpageinfo.total===0?0:1:layerpageinfo.pageNo}}</a>
            <span>/</span>
            <span>{{Math.ceil((layerpageinfo.total/layerpageinfo.pageSize))}}</span>
          </div>
          <i class="el-icon-arrow-right" @click="page('next')"></i>
        </div>
      </div>
      <!-- 店铺内容 -->
      <div class="store_main">
        <ul>
          <li v-for="item in list">
            <router-link
              :to="'/supermarket/shop_detail' + '?id=' + item.id + '&shop_id='+$route.query.shop_id"
              target="_blank"
            >
              <!-- 创新券标签 -->
              <hotLabels v-if="item.is_coupon" style="position: absolute;top: 15px;left: 15px"></hotLabels>
              <img v-if="item.lable ==='LableEpidemic'" class="fy" :src="fy" />
              <!-- 内容上部分 -->
              <div class="main_top">
                <img v-lazy="item.coverPath" :key="item.coverPath" alt />
              </div>
              <!-- 内容下部分 -->
              <div class="main_bottom">
                <p :title="item.name">{{item.name}}</p>
                <!-- 如果关键词不为空 且分割符为| -->
                <p v-if="item.keyword && item.keyword.indexOf('|')!==-1">
                  <!-- 列出前3个关键词 -->
                  <span
                    v-for="keyword,i in item.keyword.split('|')"
                    v-if="item.keyword && i < 3"
                  >{{keyword}}</span>
                </p>
                <!-- 输出一个关键词 -->
                <p v-else>
                  <span>{{item.keyword}}</span>
                </p>
                <!-- 价格 -->
                <p>
                  <span>￥{{item.price_char||'0'}}</span>
                  <span>
                    <i class="el-icon-view"></i>
                    {{item.popularity||0}}
                  </span>
                </p>
              </div>
            </router-link>
          </li>

          <li class="item_empty"></li>
          <li class="item_empty"></li>
          <li class="item_empty"></li>
          <li class="item_empty"></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import hotLabels from "@/components/mall/hot_labels.vue";
import fy from "@/assets/img/icon/fy.png";
export default {
  components: {
    hotLabels
  },
  props: {
    list: {
      type: Array
    },
    title: {
      type: String
    },
    layerpageinfo: {
      type: Object
    }
  },
  data() {
    return {
      fy: fy
    };
  },
  created() {},
  methods: {
    /** 分页*/
    page(val) {
      //总页数
      let totalPage = Math.ceil(
        this.layerpageinfo.total / this.layerpageinfo.pageSize
      );
      //点击了下一页
      if (val === "next") {
        //当前页等于0
        if (this.layerpageinfo.pageNo === 0) {
          this.layerpageinfo.pageNo += 1;
        }
        //当前页等于总页数
        if (this.layerpageinfo.pageNo === totalPage) {
          return;
        } else {
          this.layerpageinfo.pageNo += 1;
        }
      } else {
        //当前页小于等于1
        if (this.layerpageinfo.pageNo <= 1) {
          return;
        } else {
          this.layerpageinfo.pageNo -= 1;
        }
      }
      this.$emit("changePage", this.layerpageinfo);
    }
  }
};
</script>

<style lang="scss" scoped>
.store_item_list {
  .fy {
    position: absolute;
    right: 15px;
    top: 15px;
  }
  //   店铺列表
  .store_list {
    //   店铺标题
    .store_title {
      padding-top: 28px;
      height: 60px;
      display: flex;
      justify-content: space-between;
      .title_left {
        p {
          font-size: 22px;
          line-height: 60px;
          font-weight: bold;
          color: #4b5062;
        }
      }
      .title_right {
        display: flex;
        align-items: center;
        .title_right_text {
          padding: 0 7px;
          a:first-child {
            color: #ff733c;
          }
          span:nth-child(2) {
            padding: 0 5px;
          }
        }
        i {
          cursor: pointer;
        }
      }
    }
    // 店铺内容
    .store_main {
      ul {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        li {
          width: 290px;
          height: 320px;
          background-color: #fff;
          margin-top: 10px;
          position: relative;
          transition: all 0.2s;
        }

        li:hover {
          box-shadow: 0px 0px 5px 3px rgba(100, 100, 100, 0.05),
            0px 0px 5px 3px rgba(100, 100, 100, 0.05);
          transform: scale(1.03);
        }

        li:hover .bq-label {
          box-shadow: none;
          transform: none;
          border: 0px;
        }

        li:nth-child(4n + 4) {
          margin-right: 0;
        }

        .item_empty {
          height: 0;
          margin-top: 0;
        }
      }
      //   内容上部分
      .main_top {
        height: 199px;
        width: 100%;
        overflow: hidden;

        box-sizing: border-box;
        padding: 10px 10px 10px 10px;
        img {
          width: 100%;
          /*height: 100%;*/
        }
      }
      //   内容下部分
      .main_bottom {
        padding: 0 5px;
        /*text-align: center;*/
        p:first-child {
          padding-top: 20px;
          font-size: 16px;
          line-height: 26px;
          font-weight: bold;
          color: #4b5062;
          width: 90%;
          margin: 0px auto;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        //关键词
        p:nth-child(2) {
          font-size: 14px;
          line-height: 24px;
          font-weight: 400;
          color: #a4a8ba;
          margin: 10px auto;
          /*text-align: center;*/
          width: 90%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          span {
            border-right: 1px solid #d8dae0;
            padding-right: 7px;
            margin-right: 7px;
          }
          span:last-child {
            border: none;
            padding: 0px;
            margin: 0px;
          }
        }
        p:nth-child(3) {
          width: 90%;
          margin: 0px auto;
          padding-top: 5px;
          display: flex;
          justify-content: space-between;
          //价格
          span:first-child {
            display: inline-block;
            width: 60%;
            font-size: 14px;
            font-weight: bold;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            color: #ff733c;
          }
          //浏览量
          span:last-child {
            font-size: 12px;
            color: #a4a8ba;
            text-align: right;
            i {
              font-size: 14px;
              vertical-align: text-top;
            }
          }
        }
      }
    }
  }
}
</style lan>
